import { getCanonicalTimezone, UTC_ZONE } from "@helpers/timezone";

/** IANA zone of the browser, the «Your location» button. */
export const getBrowserTimezone = () =>
  getCanonicalTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone || UTC_ZONE);
